export const categories = [
  {
    id: 1,
    name: 'Electricidad',
    icon: 'ri-flashlight-line',
    description: 'Instalaciones, reparaciones y mantenimiento eléctrico',
    providerCount: 24
  },
  {
    id: 2,
    name: 'Limpieza',
    icon: 'ri-brush-line',
    description: 'Limpieza profunda, regular y especializada',
    providerCount: 38
  },
  {
    id: 3,
    name: 'Jardinería',
    icon: 'ri-plant-line',
    description: 'Diseño, mantenimiento y cuidado de jardines',
    providerCount: 19
  },
  {
    id: 4,
    name: 'Plomería',
    icon: 'ri-drop-line',
    description: 'Reparación e instalación de sistemas de agua',
    providerCount: 31
  },
  {
    id: 5,
    name: 'Pintura',
    icon: 'ri-paint-brush-line',
    description: 'Pintura interior y exterior profesional',
    providerCount: 22
  },
  {
    id: 6,
    name: 'Carpintería',
    icon: 'ri-hammer-line',
    description: 'Muebles a medida y reparaciones de madera',
    providerCount: 16
  },
  {
    id: 7,
    name: 'Aire Acondicionado',
    icon: 'ri-temp-cold-line',
    description: 'Instalación y mantenimiento de climatización',
    providerCount: 14
  },
  {
    id: 8,
    name: 'Cerrajería',
    icon: 'ri-key-line',
    description: 'Apertura, instalación y cambio de cerraduras',
    providerCount: 12
  }
];